module.exports = __webpack_public_path__ + "static/media/oil.602ef7fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oil.jpg
// module id = 5830
// module chunks = 0